import script from "./Layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./Layout.vue?vue&type=script&setup=true&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=53861c67&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53861c67"]])

export default __exports__